// @flow

import type {
  ResultListKind,
  DomainTransferBulkProducts,
  DomainProduct,
  UnavailableDomainProduct,
} from '../types';

import { CreatableResult } from './CreatableResult';
import { TransferableResult } from './TransferableResult';
import { UnavailableResult } from './UnavailableResult';

import styles from './ResultList.scss';

type Props = {
  results: DomainTransferBulkProducts,
  title: string,
  kind: ResultListKind,
};

type ResultComponentMap = {
  transfer_error: (props: { result: DomainProduct }) => React.MixedElement,
  transferable: (props: { result: DomainProduct }) => React.MixedElement,
  creatable: (props: { result: DomainProduct }) => React.MixedElement,
  unavailable: (props: {
    result: UnavailableDomainProduct,
  }) => React.MixedElement,
};

const ResultComponents: ResultComponentMap = {
  transfer_error: TransferableResult,
  transferable: TransferableResult,
  creatable: CreatableResult,
  unavailable: UnavailableResult,
};

export const ResultList = ({
  results,
  title,
  kind,
}: Props): React.MixedElement | null => {
  if (!results || results.length === 0) {
    return null;
  }

  const ResultComponent = ResultComponents[kind];

  if (!ResultComponent) {
    return null;
  }

  return (
    <div id={kind} tabIndex={-1} className={styles.root}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.rows}>
        {results.map(result => (
          // $FlowFixMe[prop-missing] TODO
          <ResultComponent key={result.fqdn} result={result} />
        ))}
      </div>
    </div>
  );
};
